import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=3531579c"
import script from "./SmsList.js?vue&type=script&lang=js&external"
export * from "./SmsList.js?vue&type=script&lang=js&external"
import style0 from "./SmsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports